import utils from '@/mixins/utils.js'

export const dataFields = {
  Gestante: {
    field: 'no_cidadao',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  'Mãe da Gestante': {
    field: 'no_mae',
    callback: (value) => {
      return value !== '' ? `​​​${value.toString()}` : ''
    },
  },
  MA: 'micro_area',
  Equipe: {
    field: 'no_equipe',
    callback: (value) => {
      return value !== '' ? `​​​${value.toString()}` : ''
    },
  },
  UBS: 'no_unidade_saude',
  'Última consulta': {
    field: 'dt_atendimento',
    callback: (value) => {
      return value
    },
  },
  IG: 'ig',
  DPP: 'dpp',
}
